import { render, staticRenderFns } from "./gatewaySystem.vue?vue&type=template&id=39de1b52&scoped=true&"
import script from "./gatewaySystem.vue?vue&type=script&lang=js&"
export * from "./gatewaySystem.vue?vue&type=script&lang=js&"
import style0 from "./gatewaySystem.vue?vue&type=style&index=0&id=39de1b52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39de1b52",
  null
  
)

export default component.exports